import { render, staticRenderFns } from "./OneTimeProfile.vue?vue&type=template&id=15c71bcb&scoped=true"
import script from "./OneTimeProfile.vue?vue&type=script&lang=js"
export * from "./OneTimeProfile.vue?vue&type=script&lang=js"
import style0 from "./OneTimeProfile.vue?vue&type=style&index=0&id=15c71bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c71bcb",
  null
  
)

/* custom blocks */
import block0 from "./OneTimeProfile.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports